// import "./App.css";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
  Outlet,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import Layout from "./components/Layout.jsx";
import Login, { ForgetPassword, OutlookCallback } from "./pages/login";
import TeamsCallback from "./components/TeamsCallback.jsx";

import { getUser } from "./actions/auth";
import { Button, Box, CircularProgress, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import CustomizedSnackbars from "./components/Snackbar.jsx";
import CustomAlert from "./components/Alert.jsx";
import TransactionList from "./pages/transaction-list";
import TransactionTypeDetails, {
  TransactionDocumentDetails,
} from "./pages/transaction-type";
import LoginMfa from "./pages/login/mfa.jsx";
import Dashboard from "./pages/dashboard";
import SavedSearch from "./pages/saved-search";
import UploadFiles from "./pages/upload-files/upload-files-list.jsx";
import UploadFilesAttachment from "./pages/upload-files/upload-files.jsx";
import AccountsList from "./pages/accounts";
import AddColumns from "./pages/add-columns/add.page.detail.columns.jsx";
import AddPageDetailColumns from "./pages/add-columns/add.page.detail.columns.jsx";
import PageDetailColumns from "./pages/add-columns/page.detail.list.jsx";
import DynamicView from "./pages/add-columns/dynamicView.jsx";
import ItemDetail from "./pages/add-columns/item.detail.jsx";
import FileCabinet from "./pages/file-cabinet/file-cabinet.jsx";
import FilesInFolderCabinet from "./pages/file-cabinet/sub-file-cabinet.jsx";
import ReportsList from "./pages/reports/reports.list.jsx";
import ReportsViewList from "./pages/reports/reports.view.jsx";
import AmortizationReportsList from "./pages/amortization-report/amortization.report.jsx";
import TransactionTotal from "./pages/transaction-total/transaction-total.jsx";
import AllTransactions from "./pages/all-transactions/all-transactions.jsx";
import TableIdentification from "./pages/table-identification/table-identification.jsx";
import Lists from "./pages/lists/list.jsx";
import ViewList from "./pages/lists/list-view.jsx";
import FairValueFormula from "./pages/transaction-type/revenue-arrangement/fair-value-formula.jsx";
import ListViewDetail from "./pages/lists/list-view-detail.jsx";
import GlobalSearch from "./pages/global-search-page/index.jsx";
import AttachmentsLists from "./pages/list-attachments/list-attachments.jsx";
import ViewAttachmentList from "./pages/list-attachments/list-view.jsx";
import SavedSearchViewList from "./pages/saved-search/reports.view.jsx";

function App() {
  return (
    <Routes>
      <Route
        path="login"
        element={
          <>
            <Login />
            <CustomizedSnackbars />
          </>
        }
      />
      <Route
        path="verify-mfa"
        element={
          <>
            <LoginMfa />
            <CustomizedSnackbars />
          </>
        }
      />
      <Route
        path="forgot-password"
        element={
          <>
            <ForgetPassword />
            <CustomizedSnackbars />
          </>
        }
      />

  
      {/*<Route path="auth/outlook/callback" element={<OutlookCallback />} />*/}
      <Route path="auth/teams/callback" element={<TeamsCallback />} />
     {/* Global search */}
    
     <Route path="global-search-page" element={     <Layout><GlobalSearch /></Layout>} />

      <Route path="/" element={<RequireAuth />}>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="saved-search" element={<SavedSearch />} />
        <Route path="saved-search/:tableName/:reportName" element={<SavedSearchViewList />} />
        <Route path="transaction-list" element={<TransactionList />} />
        <Route
          path="transaction-type/:slug"
          element={<TransactionTypeDetails />}
        />
        <Route
          path="transaction-type/:slug/:docNo"
          element={<TransactionDocumentDetails />}
        />
        <Route
          path="transaction-type/:slug/:docNo/fair-value-formula/:FVF"
          element={<FairValueFormula />}
        />
        <Route path="upload-files-list" element={<UploadFiles />} />
        <Route path="upload-files" element={<UploadFilesAttachment />} />
        <Route path="accounts" element={<AccountsList />} />
        <Route path="addColumns" element={<AddPageDetailColumns />} />
        <Route path="PageDetailColumns" element={<PageDetailColumns />} />
        <Route path="salesOrderDynamicView" element={<DynamicView />} />
        <Route path="salesOrderDynamicView/:id" element={<ItemDetail />} />
        <Route path="fileCabinet" element={<FileCabinet />} />
        <Route path="fileCabinet/*" element={<FilesInFolderCabinet />} />
        <Route path="reports" element={<ReportsList />} />
        <Route path="reports/:tableName/:reportName" element={<ReportsViewList />} />
        <Route path="lists" element={<Lists />} />
        <Route path="lists/:tableName" element={<ViewList />} />
        {/* <Route path="lists/:tableName/:internal_id" element={<ListViewDetail />} />  */}
        <Route path="list-attachments"  element={<AttachmentsLists/>}/>
        <Route path="list-attachments/:tableName" element={<ViewAttachmentList />} /> 
        {/* <Route path="list-attachments/:tableName/:internal_id" element={<AttachListViewDetail />} />  */}
        <Route
          path="amortization-reports"
          element={<AmortizationReportsList />}
        />
       
        <Route path="transaction-total" element={<TransactionTotal />} />        
        <Route path="all-transactions" element={<AllTransactions />} />   
        <Route path="table-identification" element={<TableIdentification />} />    
      </Route>

      <Route path="*" element={<Nothing />}></Route>
    </Routes>
  );
}

export default App;

function RequireAuth() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const {
    isLoggedIn,
    suspense,
    data: user,
  } = useSelector((state) => state.user);
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && !isLoggedIn) {
      // console.log("Token but not logged in");
      dispatch(getUser(token));
    } else if (isLoggedIn) {
      // console.log("Logged in");
      navigate(
        pathname === "/"
          ? user.role === "admin"
            ? "/transaction-list"
            : "/transaction-list"
          : pathname
      );
    } else {
      // console.log("No token no logged in")
      navigate("/login", { replace: true });
    }
  }, [pathname, isLoggedIn]);

  return suspense ? (
    <Loading />
  ) : (
    <>
      <Layout>
        <Outlet />
        <CustomizedSnackbars />
        <CustomAlert />
      </Layout>
    </>
  );
}

function RequireAdminAuth({ loggedIn, role = "user" }) {
  if (loggedIn) {
    if (role === "admin") {
      return (
        <>
          <Outlet />
          {/* <AlertBox />  */}
        </>
      );
    } else {
      return <AccessDenied />;
    }
  } else {
    return <Navigate to="/login" replace />;
  }
}

function Nothing() {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{ width: "100%", height: "100vh" }}
    >
      <Box textAlign="center">
        <Typography variant="h3" fontWeight="600">
          Nothing Here !!!
        </Typography>
        <br />
        <Link to="/">
          <Button variant="contained">Back To Home</Button>
        </Link>
      </Box>
    </Box>
  );
}

function AccessDenied() {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{ width: "100%", height: "100vh" }}
    >
      <Box textAlign="center">
        <Typography variant="h3" fontWeight="600">
          Access Denied !!!
        </Typography>
        <Typography variant="h6">Only Allowed to Admins.</Typography>
        <br />
        <Link to="/">
          <Button variant="contained">Back To Home</Button>
        </Link>
      </Box>
    </Box>
  );
}

function Loading() {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{ width: "100%", height: "100vh" }}
    >
      <Box textAlign="center">
        {/* <Typography variant="h3" fontWeight="600">
          Logging In ...
        </Typography>
        <br /> */}
        <CircularProgress />
      </Box>
    </Box>
  );
}
